import Color from 'color';

/** "Crafted modern" design tokens. Mirrored in src/_tokens.scss — change both. */
export const mb = {
  ground: '#F5F0EA',
  surface: '#FFFDF9',
  side: '#ECE4DB',
  sideLine: '#DDD0C3',
  line: '#E0D4C8',
  lineSoft: '#EBDDD2',
  gridLine: '#F0E4DA',
  control: '#D3C5B8',
  ink: '#1F1A17',
  muted: '#685B53',
  disabledFill: '#E3D6CC',
  green: '#135635',
  greenHover: '#0E4229',
  mint: '#DBFEEC',
  todayWash: '#F6FFF9',
  clayInk: '#7A3A27',
  claySoft: '#F5DCD0',
  clay: '#E0A189',
  terracotta: '#C2603F',
  danger: '#A8432A',
  dangerSoft: '#F6D5CB',
  highlight: '#D9822B',
  iconWashActive: 'rgba(219, 254, 236, 0.3)',
  iconWashActiveSecondary: '#BDEFD3',
  rooms: [
    { dot: '#D98A5B', soft: '#F8E3D6' },
    { dot: '#C9A43A', soft: '#F5ECCB' },
    { dot: '#7C8BD6', soft: '#E2E6F8' },
    { dot: '#6FA27A', soft: '#DDEDDF' },
  ],
  radius: { control: 6, card: 8, chip: 4 },
  /** MUI spacing units: page inset 24px desktop / 12px phone, card padding 20px / 16px. */
  layout: { pageInset: { xs: 1.5, md: 3 }, cardPadding: { xs: 2, md: 2.5 } },
  cardShadow: '0 1px 2px rgba(31, 26, 23, 0.05)',
  drawerShadow: '0 10px 40px rgba(58, 43, 38, 0.18)',
  backdrop: 'rgba(58, 43, 38, 0.32)',
  scrollThumb: 'rgba(31, 26, 23, 0.2)',
  stickyShadow: '0 6px 8px -2px rgba(31, 26, 23, 0.06)',
  /** Documentation only: the menu SVGs carry these washes themselves. */
  iconWashes: ['#F3C9B6', '#F1DE9E', '#CBD2F3', '#C5E2C9', '#F3CBD7'],
} as const;

export type MbTokens = typeof mb;

export const DEFAULT_ORDER_PAGE_COLOR = '#6577b3';

/** A workshop color as a pale fill: 72% of the way to surface. */
export const softFill = (hex: string): string =>
  Color(hex || DEFAULT_ORDER_PAGE_COLOR)
    .mix(Color(mb.surface), 0.72)
    .hex();

/** The 1px inset line for that fill: 35% of the way to surface; near-white colors fall back to the control line. */
export const insetLine = (hex: string): string => {
  const line = Color(hex || DEFAULT_ORDER_PAGE_COLOR).mix(Color(mb.surface), 0.35);
  return line.contrast(Color(mb.surface)) < 1.15 ? mb.control : line.hex();
};
